<template>
  <div class="banner_container">
    <el-carousel
      :indicator-position="indicatorPosition"
      :loop="loop"
      :height="height"
      :autoplay="true"
      :interval="8000"
      ref="carouse"
      @change="handerChange"
    >
      <el-carousel-item v-for="(item, index) in lists" :key="index">
        <div class="banner-extra">
          <h2
            class="banner-extra-title"
            v-scroll-animate="{
              animation: 'fadeInDown',
              observerOnce: false,
              duration: 600,
            }"
          >
            {{ item.title }}
          </h2>
          <h4
            class="banner-extra-subTitle"
            v-scroll-animate="{
              animation: 'fadeInDown',
              observerOnce: false,
              duration: 500,
              delay: 400,
            }"
          >
            {{ item.subTitle }}
          </h4>
          <span
            class="more_button"
            @click="moreNews(item.linkUrl)"
            v-scroll-animate="{
              animation: 'fadeInUp',
              observerOnce: false,
              duration: 500,
              delay: 400,
            }"
            >{{ item.buttonLabels }}</span
          >
        </div>
        <template v-if="item.carouselBgType === '1'">
          <img
            v-if="item.fileUrl"
            class="c_img bgImg"
            :src="item.fileUrl"
            alt="轮播图"
          />
        </template>
        <template v-else-if="item.carouselBgType === '2'">
          <video
            v-if="item.fileUrl"
            class="c_video"
            :src="item.fileUrl"
            preload="auto"
            autoplay
            muted
            loop
          />
        </template>
        <!-- <img
          class="c_img maskLayerImg"
          :src="require('@/assets/images/homeImg/maskLayer.png')"
          alt="蒙层"
        /> -->
      </el-carousel-item>
    </el-carousel>
    <ul class="trigger-box">
      <li
        class="trigger-item"
        v-for="(item, index) in lists"
        :key="index"
        :class="sliderIndex === index ? 'active' : ''"
        @click="handerSlidedr(index)"
      >
        <span class="line"></span>
        <span class="trigger-label">{{ item.indicator }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    height: {
      type: String,
      default: () => {
        return "500px";
      },
    },
    // 指示器的位置
    indicatorPosition: {
      type: String,
      default: () => {
        return "outside"; // none
      },
    },
    // 是否循环显示
    loop: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    lists: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      sliderIndex: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {
    console.log("this.lists--", this.lists);
  },
  methods: {
    /*
     * @Description: 打开链接
     * @MethodAuthor:  liulian
     * @Date: 2023-07-26 09:17:29
     * @param: ''
     */
    openUrl(item) {
      if (item.bannerLink) {
        window.open(item.bannerLink, "_blank");
      }
    },
    handerChange(index) {
      this.sliderIndex = index;
    },
    handerSlidedr(index) {
      this.sliderIndex = index;
      this.$refs.carouse.setActiveItem(index);
    },
    moreNews(path) {
      // TODO
      this.$uniFun.openInCurrentTab(`${path}`);
    },
  },
};
</script>

<style scoped lang="scss">
.banner_container {
  position: relative;
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
  .c_video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    object-fit: cover;
  }
  .c_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .bgImg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
  }
  .maskLayerImg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
  }
  .trigger-box {
    position: absolute;
    bottom: 16px;
    left: 50%;
    width: 965px;
    font-size: 14px;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.8);
    z-index: 10;
    display: flex;
    .trigger-item {
      flex: 1;
      margin-right: 50px;
      min-width: 224px;
      cursor: pointer;
      .line {
        display: block;
        width: 40px;
        height: 2px;
        margin-bottom: 16px;
        background-color: #fff;
        vertical-align: middle;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      .trigger-label {
      }
      &.active {
        .line {
          width: 100%;
          background-color: #2f69f2;
        }
      }
    }
  }
  .banner-extra {
    position: absolute;
    top: 160px;
    left: 50%;
    transform: translateX(-50%);
    width: 965px;
    z-index: 10;
    color: #fff;
    z-index: 10;
    .banner-extra-title {
      margin-bottom: 24px;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      line-height: 56px;
      text-align: left;
      font-style: normal;
    }
    .banner-extra-subTitle {
      margin-bottom: 90px;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
      line-height: 40px;
      text-align: left;
      font-style: normal;
    }
  }
  .more_button {
    display: inline-block;
    width: 180px;
    height: 40px;
    line-height: 40px;
    background: #fff;

    color: #005ab4;
    border-radius: 20px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
    box-sizing: border-box;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
